/**
 * Structured marketing capability catalog for features page domains and home highlights.
 */

/** @typedef {'hotLunch' | 'calendar' | 'volunteers' | 'communications' | 'meetings' | 'documents' | 'schoolYear' | 'fundraising' | 'budget' | 'trustPlatform'} MarketingFeatureDomainId */

/** Deep-dive section order on /features. */
export const MARKETING_FEATURE_DOMAIN_IDS = [
  'hotLunch',
  'calendar',
  'volunteers',
  'communications',
  'meetings',
  'documents',
  'schoolYear',
  'fundraising',
  'budget',
  'trustPlatform',
];

/** Home page "what's included" tiles (short labels; link into /features anchors). */
export const MARKETING_HOME_INCLUDED_IDS = [
  'hotLunch',
  'volunteers',
  'budget',
  'communications',
  'meetings',
  'fundraising',
];

/** Features page anchor per home included tile id. */
export const MARKETING_HOME_INCLUDED_ANCHORS = {
  hotLunch: 'hot-lunch',
  volunteers: 'volunteers',
  budget: 'budget',
  communications: 'communications',
  meetings: 'meetings',
  fundraising: 'fundraising',
};

/** URL anchor per feature domain id. */
export const MARKETING_DOMAIN_ANCHORS = {
  hotLunch: 'hot-lunch',
  calendar: 'calendar',
  volunteers: 'volunteers',
  communications: 'communications',
  meetings: 'meetings',
  documents: 'documents',
  schoolYear: 'school-year',
  fundraising: 'fundraising',
  budget: 'budget',
  trustPlatform: 'trust-platform',
};

/** Home how-it-works teaser steps. */
export const MARKETING_HOME_STEP_IDS = ['schoolSite', 'register', 'runYear'];

/** Full how-it-works page steps. */
export const MARKETING_HOW_IT_WORKS_STEP_IDS = ['schoolSite', 'register', 'runYear', 'roles'];

/** Roles on the how-it-works page. */
export const MARKETING_HOW_IT_WORKS_ROLE_IDS = ['parents', 'executives', 'coordinators'];

/** FAQ accordion items. */
export const MARKETING_FAQ_IDS = [
  'whatIsPacHub',
  'whoIsItFor',
  'pricing',
  'pilot',
  'hotLunchIncluded',
  'replaceStack',
  'dataSelling',
  'languages',
  'schoolAdmin',
  'ownership',
];

/** @type {string[]} */
export const MARKETING_TRUST_KEYS = [
  'secure',
  'noDataSelling',
  'oneFee',
  'privacyConsent',
  'pacControl',
  'languages',
];
